import { FieldTypes } from '../../constants/FieldTypes'
import { CheckboxField, DateField, FieldMap, ListField, TextField } from '../../types/forms/fields'

const labNameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Lab name',
}

const resultField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Result',
  optional: true,
}

const dateField: DateField = {
  type: FieldTypes.DATE,
  placeholder: 'Date',
  optional: true,
}

const reviewedField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Reviewed',
  optional: true,
}

const additionalLabItemFields: FieldMap = {
  name: 'Lab',
  children: {
    labName: labNameField,
    result: resultField,
    date: dateField,
    reviewed: reviewedField,
  },
}

export const additionalLabsField: ListField = {
  name: 'Additional Labs',
  itemName: 'Lab',
  displayedField: 'labName',
  itemFields: additionalLabItemFields,
  optional: true,
}
